require('dom-slider');
const { slideUp, slideDown } = window.domSlider;

const tabGrids = document.querySelectorAll('.block-tabs__grid');

const toggleTabs = (e) => {
	e.preventDefault();
	const thisTabButton = e.currentTarget;

	thisTabButton.parentElement.classList.add('active');

	const tabContents =
		thisTabButton.parentElement.parentElement.querySelectorAll(
			'.block-tabs__tab.active .block-tabs__tab-content'
		);

	if (tabContents.length) {
		tabContents.forEach((tabContent) => {
			if (tabContent.parentElement !== thisTabButton.parentElement) {
				tabContent.parentElement.classList.remove('active');

				slideUp({
					element: tabContent,
					slideSpeed: 400,
					easing: 'ease-in-out',
				});
			}
		});
	}

	slideDown({
		element: thisTabButton.parentElement.querySelector(
			'.block-tabs__tab-content'
		),
		slideSpeed: 400,
		easing: 'ease-in-out',
	});
};

const resizeGrid = () => {
	if (tabGrids.length) {
		tabGrids.forEach((tabGrid) => {
			tabGrid.style.removeProperty('--marginTop');
			tabGrid.nextElementSibling.style.removeProperty('--marginTop');

			const offset =
				tabGrid.offsetTop - tabGrid.nextElementSibling.offsetTop;

			if (offset > 0) {
				tabGrid.style.setProperty('--marginTop', `${offset}px`);
			} else {
				tabGrid.style.setProperty('--marginTop', `0px`);
			}
		});
	}
};

const tabs = () => {
	if (tabGrids.length) {
		tabGrids.forEach((tabGrid) => {
			const tabButtons = tabGrid.querySelectorAll('.block-tabs__button');

			tabButtons.forEach((tabButton, key) => {
				if (0 === key) {
					tabButton.parentElement.classList.add('active', 'visible');
					tabButton.nextElementSibling.classList.remove(
						'DOM-slider-hidden'
					);
					tabButton.nextElementSibling.setAttribute(
						'aria-hidden',
						'false'
					);
				}

				tabButton.addEventListener('click', toggleTabs);
			});

			tabGrid.classList.add('initialized');
		});

		resizeGrid();
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		tabs();
	},
	loaded() {},
	resized() {
		resizeGrid();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
